import { WebParameterContext, WebResponesContext } from '../../model/common';
export class ServicesawakenService{
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    webcontext.RequestBody={};
    webcontext.RequestBody.Type=5;//潜在客户
    return webcontext;
  }

}